import {
  FilterMode,
  AssociatedDocumentSignedEdition_OrderBy,
  AssociatedDocumentSignedEdition,
  SortOrder,
  AssociatedDocumentSignedEdition_Filter,
} from "../../../api/graphql";
import { getApiInstance } from "../../../api";
import { nullToUndefinedRecursive } from "../../../common/utils";

export const associatedDocumentSignedEditionService = {
  createOne: () => (): Promise<string> => new Promise(() => ""),
  getOne: async (id: string, accessToken: string, activityStore: any) => {
    const api = getApiInstance(accessToken, activityStore);
    const result = await api.associatedDocumentSignedEditionOne({ id });
    return result.associatedDocumentSignedEditionOne as AssociatedDocumentSignedEdition;
  },
  getFilteredList: async (
    accessToken: string,
    offset: number,
    take: number,
    searchValue: string,
    _language: string = "es",
    orderBy: AssociatedDocumentSignedEdition_OrderBy[] | null = null,
    filter: AssociatedDocumentSignedEdition_Filter | null = null,
    activityStore: any
  ) => {
    const api = getApiInstance(accessToken, activityStore);

    let where: AssociatedDocumentSignedEdition_Filter | undefined;
    if (searchValue !== "") {
      where = { name: { contains: searchValue, mode: FilterMode.Insensitive } };
    }

    if (filter) {
      if (where) {
        where = { AND: [filter, where] };
      } else {
        where = filter;
      }
    }

    const result = await api.associatedDocumentSignedEditionListWithOffset({
      offset,
      take,
      orderBy: orderBy ? orderBy : [{ name: SortOrder.Asc }],
      where,
    });
    const list = nullToUndefinedRecursive(
      result.associatedDocumentSignedEditionListWithOffset
    ) as AssociatedDocumentSignedEdition[];
    return { list, orderBy };
  },
};
